export default __webpack_public_path__ + "static/media/FeaturedAuthors.4dadbb9c.svg";